/*
 * @Author: wangwenqiu@suanier.com wangwenqiu@suanier.com
 * @Date: 2023-04-11 17:37:51
 * @LastEditors: liutq
 * @LastEditTime: 2025-03-21 16:58:38
 * @FilePath: \vr-exp-h5-frontend\src\types\device.js
 * @Description: 
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */


import Explorer from '@/assets/images/sidebar/Explorer@2x.png'
import V_S30 from '@/assets/images/sidebar/V-S30@2x.png'
import M_S30 from '@/assets/images/sidebar/V-M30@2x.png'
import M_S60 from '@/assets/images/sidebar/V-M60@2x.png'
import V_M50 from '@/assets/images/sidebar/V-M50@2x.png'

// 阿拉伯语图片
import ExplorerAr from '@/assets/images/sidebar/Explorer_ar@2x.png'
import V_S30Ar from '@/assets/images/sidebar/V-S30_ar@2x.png'
import M_S30Ar from '@/assets/images/sidebar/V-M30_ar@2x.png'
import M_S60Ar from '@/assets/images/sidebar/V-M60_ar@2x.png'
import V_M50Ar from '@/assets/images/sidebar/V-M50ar@2x.png'

/**
 * 报告类型 1 EXP 2 S30
 */
export const E_DEVICE_TYPE = {
    EXP: 1,
    S30: 2,
    M30: 3,
	M60: 4,
    M50: 5,
}

/**
 * 设备类型名称 1 EXP 2 S30
 */
export const E_DEVICE_NAME_TYPE =  {
    [E_DEVICE_TYPE.EXP]: 'Visbody-R explorer',
    [E_DEVICE_TYPE.S30]: 'Visbody-S30/S20',
    [E_DEVICE_TYPE.M30]: 'Visbody-M30',
	[E_DEVICE_TYPE.M60]: 'Visbody-M60',
	[E_DEVICE_TYPE.M50]: 'Visbody-M50',
}
/**
 * 设备类型icon 1 EXP 2 S30
 */
export const E_DEVICE_IMAGE_PATH =  {
    [E_DEVICE_TYPE.EXP]: Explorer,
    [E_DEVICE_TYPE.S30]: V_S30,
    [E_DEVICE_TYPE.M30]: M_S30,
	[E_DEVICE_TYPE.M60]: M_S60,
	[E_DEVICE_TYPE.M50]: V_M50,
}
//阿拉伯语
export const E_DEVICE_IMAGE_PATH_AR =  {
    [E_DEVICE_TYPE.EXP]: ExplorerAr,
    [E_DEVICE_TYPE.S30]: V_S30Ar,
    [E_DEVICE_TYPE.M30]: M_S30Ar,
	[E_DEVICE_TYPE.M60]: M_S60Ar,
	[E_DEVICE_TYPE.M50]: V_M50Ar,
}

/**
 * m30 体成分报告显示项
 */
export const E_M30_REPORT_ITEM = ["WT", "BFM", "SM", "TBW", "PROTEIN", "BMI", "PBF", "FFM", "BMR"]

export function m30Test() {
    const deviceType = JSON.parse(window.localStorage.getItem('deviceType'))
    return deviceType === 3
}


/**
 * 通过访问域名获取产品类型
 * @param {*} origin 访问域名
 * @returns 产品类型
 */
export function getProductTypeByOrigin(origin) {
    let type = ''
    if (origin.includes('m60')) {
        type = 'M60'
    }else if(origin.includes('192.168.31.5')) {
        type = 'M60'
    }
    return type
}

export function isM60() {
    const data = window.localStorage.getItem('deviceId')
    console.log(`当前设备sn${JSON.stringify(data)}`)
    if (data === null) {
        const origin = location.origin
        console.log(`当前域名：${origin}`)
        if(getProductTypeByOrigin(origin) === 'M60'){
             console.log(`当前设备类型：${getProductTypeByOrigin(origin)}`)
            return true
        }
        return
    }
    return data.slice(0, 2) === 'M8' || data.slice(0, 2) === 'N8'
}
